"use client";
import { Button } from "@kyan/ui";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";

import { useComboRfqController } from "./ComboRFQButton.controller";

export const ComboRFQButton: React.FC = () => {
  const { isDisabled, isLoading, buttonLabel, handleTrade } =
    useComboRfqController();

  return (
    <ConnectWalletWrapper className="mt-4 min-w-37.5 place-self-end whitespace-nowrap">
      <Button
        size="lg"
        disabled={isDisabled}
        isLoading={isLoading}
        className="mt-4 min-w-37.5 place-self-end whitespace-nowrap shadow-none"
        onClick={handleTrade}
      >
        {buttonLabel}
      </Button>
    </ConnectWalletWrapper>
  );
};
